import React, { useState } from "react";
import
{
	Dialog,
	DialogContent,
	DialogTitle,
	Box,
	Stack,
	Typography
} from "@mui/material";
import
{
	AccountRecoveryIconUrls,
	ChipIconUrls,
	ComplianceAuditIconUrls,
	ComplianceIconUrls,
	ConsultingIconUrls,
	contentBoxStyle,
	IncidentResponseIconUrls,
	ProtectionIconUrls,
	SupplyChainManagementIconUrls,
	TwoFactorAuthIconUrls,
	cardStyle
} from "../shared/Theme";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";
import AdditionalServiceCard from "../elements/Services/AdditionalServiceCard";
import AdditionalServiceInfoCard from "../elements/Services/AdditionalServiceInfoCard";
import AdditionalServicesForm from "../elements/Services/AdditionalServicesForm";

const AdditionalServices = () =>
{
	let [infoVisibility, setInfoVisibility] = useState({});
	let [selectedService, setSelectedService] = useState("");
	let [selectedServiceName, setSelectedServiceName] = useState("");
	let [showForm, setShowForm] = useState(false);

	const handleOpen = () => setShowForm(true);
	const handleClose = () => setShowForm(false);
	const toggleHelp = (event, name) =>
	{
		event.preventDefault();
		let newVar = structuredClone(infoVisibility);
		newVar[name] = !newVar[name];
		setInfoVisibility(newVar);
	};
	const setService = (title, name) =>
	{
		setSelectedService(name);
		setSelectedServiceName(title);
		handleOpen();
	};
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar />
			<Box component="main" sx={{ flexGrow: 1, bgcolor: "background.default" }}>
				<Header pageTitle="Additional Services" />
				<Box sx={contentBoxStyle}>
					<Stack
						sx={{ ...cardStyle, width: "80%", margin: "auto", paddingBottom: "1em", padding: "1em" }}
						justifyContent="center"
						alignItems="center"
						spacing="2em"
					>
						<Typography
							variant="h5"
							sx={{ width: "100%", textAlign: "center", fontWeight: "bold", marginTop: "1em" }}
						>
							Additional Services
						</Typography>
						<Stack
							direction="column"
							alignItems="center"
							spacing={2}
							justifyContent="center"
							sx={{ width: "80%", margin: "auto" }}
						>
							<Stack
								direction="column"
								alignItems="center"
								spacing={2}
								justifyContent="center"
								sx={{ width: "80%", margin: "auto" }}
							>
								<Stack
									direction="row"
									spacing={2}
									alignItems="flex-start"
									justifyContent="center"
									sx={{ width: "100%", margin: "auto" }}
								>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											icon={ProtectionIconUrls.light}
											title="Endpoint Protection - EDR, XDR and MDR"
											onClick={(title) =>
											{
												setService(title, "endpoint_protection");
											}}
											isLocal={true}
											helpToggle={(event) =>
											{
												toggleHelp(event, "endpoint_protection");
											}}
										/>
										<AdditionalServiceInfoCard
											title="Endpoint Protection"
											isVisible={infoVisibility["endpoint_protection"]}
										>
											<p>
												Access a leading endpoint protection, malware detection
												and ransomware prevention solution to protect you at the
												point of compromise
												<br />
												Options include :
												<br />
												EDR - Endpoint Detection & Response XDR - Extended
												Detection & Response MDR - Managed Detection & Response
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Incident Response"
											icon={IncidentResponseIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "incident_response");
											}}
											isLocal={false}
											helpToggle={(event) =>
											{
												toggleHelp(event, "incident_response");
											}}
										/>
										<AdditionalServiceInfoCard
											title="Incident Response"
											isVisible={infoVisibility["incident_response"]}
										>
											<p>
												If the worst happens, an Incident Response licence gives
												you direct and immediate access to IR experts and a
												range of support services - ready to triage and contain
												an incident, investigate the extent of a breach, deal
												with the fallout and get you back to operational as
												quickly as possible
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Hyper Real GenAI Phishing Tests"
											icon={ChipIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "phishing");
											}}
											isLocal={false}
											helpToggle={(event) =>
											{
												toggleHelp(event, "phishing");
											}}
										/>
										<AdditionalServiceInfoCard
											title="Hyper Real GenAI Phishing Tests"
											isVisible={infoVisibility["phishing"]}
										>
											<p>Use good AI to fight bad AI.</p>
											<p>
												There was a 76% increase in phishing attacks in 2024,
												almost entirely due to the use of Generative AI by
												attackers.
												<br />
												In just a few clicks - send hyper real, incredibly
												convincing phishing tests at scale to your users to
												prepare them for what’s coming
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
								</Stack>
								<Stack
									direction="row"
									spacing={2}
									alignItems="center"
									justifyContent="center"
									sx={{ width: "100%", margin: "auto" }}
								></Stack>
							</Stack>
							<Stack
								direction="column"
								alignItems="center"
								sx={{ width: "80%", margin: "auto" }}
							>
								<Stack
									direction="row"
									spacing={2}
									alignItems="flex-start"
									justifyContent="center"
									sx={{ width: "100%", margin: "auto" }}
								>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Multi Factor Authentication"
											icon={TwoFactorAuthIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "authentication");
											}}
											isLocal={true}
											helpToggle={(event) =>
											{
												toggleHelp(event, "authentication");
											}}
											url="/dash"
										/>
										<AdditionalServiceInfoCard
											title="Multi Factor Authentication"
											isVisible={infoVisibility["authentication"]}
										>
											<p>MFA is a vital security control - a must have.</p>
											<p>
												It adds extra security beyond passwords, requiring
												multiple verification methods like codes or
												fingerprints. This makes hacking much harder, protecting
												your accounts, your data, and your business
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Supply Chain Risk Monitoring"
											icon={SupplyChainManagementIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "risk_monitoring");
											}}
											isLocal={false}
											helpToggle={(event) =>
											{
												toggleHelp(event, "risk_monitoring");
											}}
											url="https://app.user-training.com/"
										/>
										<AdditionalServiceInfoCard
											title="Supply Chain Risk Monitoring"
											isVisible={infoVisibility["risk_monitoring"]}
										>
											<p>
												Also referred to as TPRM (third party risk management),
												it refers to the recognition of the risk posed to your
												business by connecting systems and services with your
												suppliers, and the use of a technilogy or service to
												better understand your suppliers security posture and
												any risk they pose to your business as a result.
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Password Manager"
											icon={AccountRecoveryIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "password_manager");
											}}
											isLocal={false}
											helpToggle={(event) =>
											{
												toggleHelp(event, "password_manager");
											}}
										/>
										<AdditionalServiceInfoCard
											title="Password Manager"
											isVisible={infoVisibility["password_manager"]}
										>
											<p>
												Password managers securely store and organize all your
												passwords in one place. They generate strong, unique
												passwords for each account, eliminating the need to
												remember them. This significantly improves security and
												reduces the risk of data breaches caused by weak or
												reused passwords.
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
								</Stack>
							</Stack>
							<Stack
								direction="column"
								alignItems="center"
								justifyContent="center"
								sx={{ width: "80%", margin: "auto" }}
							>
								<Stack
									direction="row"
									spacing={2}
									alignItems="flex-start"
									justifyContent="center"
									sx={{ width: "100%", margin: "auto" }}
								>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Cyber Security Consultancy"
											icon={ConsultingIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "consultancy");
											}}
											isLocal={true}
											helpToggle={(event) =>
											{
												toggleHelp(event, "consultancy");
											}}
										/>
										<AdditionalServiceInfoCard
											title="Cyber Security Consultancy"
											isVisible={infoVisibility["consultancy"]}
										>
											<p>
												Consultancy provides you with expert advice and guidance
												on protecting your business. Assess vulnerabilities,
												develop security strategies, and help implement best
												practices to mitigate cyber threats. This strengthens
												your defences, reduces risk and exposure, and ensures
												business continuity in the face of ever evolving cyber
												threats.
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Compliance & Regulations"
											icon={ComplianceIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "compliance");
											}}
											isLocal={false}
											helpToggle={(event) =>
											{
												toggleHelp(event, "compliance");
											}}
										/>
										<AdditionalServiceInfoCard
											title="Compliance and Regulations"
											isVisible={infoVisibility["compliance"]}
										>
											<p>
												Consider Cyber Essentials Plus, the UK government scheme
												for baseline cybersecurity and controls.
											</p>
											<p>
												For more comprehensive security, ISO 27001 provides a
												framework for managing information security. Both
												enhance cyber resilience, build customer trust, and can
												provide a competitive advantage.
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
									<Stack direction="column" spacing={2}>
										<AdditionalServiceCard
											title="Cyber Security Audit"
											icon={ComplianceAuditIconUrls.light}
											onClick={(title) =>
											{
												setService(title, "audit");
											}}
											isLocal={false}
											helpToggle={(event) =>
											{
												toggleHelp(event, "audit");
											}}
										/>
										<AdditionalServiceInfoCard
											title="Cyber Audit - A Good Starting Point"
											isVisible={infoVisibility["audit"]}
										>
											<p>
												A cyber audit checks your security controls and plans,
												and provides insight into weaknesses in your systems. It
												helps you understand your business risks, improve your
												defences, and show compliance. This strengthens
												security, prevents attacks, and can help build trust.
											</p>
										</AdditionalServiceInfoCard>
									</Stack>
								</Stack>
							</Stack>
						</Stack>
					</Stack>
				</Box>
			</Box>

			<Dialog
				open={showForm}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				fullWidth={true}
				maxWidth="md"
			>
				<DialogTitle id="alert-dialog-title">
					{selectedServiceName} Enquiries
				</DialogTitle>
				<DialogContent>
					<AdditionalServicesForm
						serviceName={selectedServiceName}
						selectedService={selectedService}
						companyName="todo"
						handleClose={handleClose}
					/>
				</DialogContent>
			</Dialog>
		</Box>
	);
};

export default AdditionalServices;
